module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }